import { render, staticRenderFns } from "./registerAs.vue?vue&type=template&id=1d47f274&"
import script from "./registerAs.vue?vue&type=script&lang=js&"
export * from "./registerAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports